import $ from 'jquery';
import Header from '../template-parts/header/header.js';
import Footer from '../template-parts/footer/footer.js';
import FreshHarvest from '../template-parts/fresh-harvest/fresh-harvest.js';

$(function(){
    const h = new Header();
    const f = new Footer();

    document.querySelectorAll('[data-fresh-harvest]').forEach((el) => {
        new FreshHarvest(el);
    });
});